import React from "react";
import SEO from "../../../hooks/SEO";
import Service from "../Service";
import { serviceDetails, siteMeta } from "../../../data/mockData";

const Mining = () => (
  <>
    <SEO
      title={`${serviceDetails.mining.title} | Refwa`}
      description={serviceDetails.mining.intro}
      name={siteMeta.name}
      type="website"
    />
    <Service service={serviceDetails.mining} />
  </>
);

export default Mining;
